"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gql = void 0;
var gql = function () {
    var parts = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        parts[_i] = arguments[_i];
    }
    throw new Error('should be replaced by ts transformer');
};
exports.gql = gql;
//# sourceMappingURL=helpers.js.map